import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import SubscribArea from "../../common/SubscribArea";
import ServiceWrap from "./ServiceWrap";

function Service() {
  return (
    <>
      <div className="creasoft-wrap">
        <Breadcrumb pageName="Our Services" pageTitle="Our Services" />
        <meta name="robots" content="noindex" />
        <ServiceWrap />
        <SubscribArea />
      </div>
    </>
  );
}

export default Service;
